import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Error } from '../../exception';
import { appInjector } from '../../app-injector';
import { ComponentModifyShipping } from '../component-modify-shipping';
import { ExpeditionsService } from '../../services/expeditions.service';
import { SesionService } from '../../services/sesion.service';
import { ErrorModalComponent } from '../../error-modal/error-modal.component';
import { ChangeType } from '../../enums/change-type.enum';
import { Change } from '../../comun/recipient-services/change';
import { ExpeditionModification } from '../../comun/recipient-services/expedition-modification';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ExceptionHttp } from '../../services/api.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-confirm-change-modal',
  templateUrl: './confirm-change-modal.component.html'
})
export class ConfirmChangeModalComponent extends ComponentModifyShipping implements OnInit {
  changesAvailable: ChangeType;
  moreChangesCanBeMade = false;
  cdrParent: ChangeDetectorRef;

  constructor(
    private service: ExpeditionsService,
    private langService: LanguageService,
    public modal: BsModalRef,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  async ngOnInit() {
    try {
      if (!this.change.canBeCombined) {
        this.moreChangesCanBeMade = false;
      } else if (this.sesion.changesAvailable.length == 1) {
        this.moreChangesCanBeMade = false;
      } else {

        this.changesAvailable = await this.service.typesChangeAvailable(this.change.type).toPromise();
        this.moreChangesCanBeMade = !(this.changesAvailable == ChangeType.Ninguno || this.changesAvailable == this.sesion.changesMade);
      }
    } catch (err) {
      ErrorModalComponent.show(err)
    }

    this.sesion.changes.forEach(change => {
      if (change.type != this.change.type) {
        this.changes.push(change);
        this.acceptPolicyPrivacy = true;
      }
    });

    this.changes.push(this.change);
  }

  change: Change;
  changes = new Array<Change>();
  zipCode: string = '';
  acceptPolicyPrivacy: boolean;

  get zipCodeMask(): string {
    return this.sesion.zipCodeMask;
  }

  async confirmExit(frm: NgForm) {
    const expedition = this.sesion.expedition$.getValue();
    if (!this.acceptPolicyPrivacy) {
      frm.controls.acceptPolicyPrivacy.markAsTouched();
      frm.controls.acceptPolicyPrivacy.setErrors({ 'politicaPrivacidad': this.langService.instant('ModifyDelivery.PrivacyPolicyInfo') }, { emitEvent: true })
      this.cdrParent.detectChanges();
    }

    if( this.zipCode === '') {
      frm.controls.zipCode.markAsTouched();
      frm.controls.zipCode.setErrors({ 'zipCode': this.langService.instant('ModifyDelivery.WrongZipCodeInfo') }, { emitEvent: true })
      return
     }


    if (frm.invalid) {
      return;
    }
    try {
      this.sesion.gaConfirmacion(this.change.type);
      const expedition = this.sesion.expedition$.getValue();
      const modification: ExpeditionModification = {
        TlgExpeditionNumber: expedition.TLGNumber,
        ExpeditionZipCode: this.zipCode,
        IncidenceNumber: expedition.IncidenceNumber,
        IncidenceAgencyCode: expedition.IncidenceAgencyCode,
        Changes: this.changes
      }


      await this.sesion.modify(modification);

      this.changes.forEach(change => {
        change.fillOutExpedition(this.sesion.expedition$.getValue());
      });

      this.modal.hide();
    } catch (error) {
      const mistakeHttp = (error as ExceptionHttp);
      if (mistakeHttp && mistakeHttp.status == 400) {
        frm.controls.zipCode.markAsTouched();
        frm.controls.zipCode.setErrors({ 'zipCode': mistakeHttp.message }, { emitEvent: true })
      } else {
        ErrorModalComponent.show(error);
      }
    }
  }

  async confirmChange(frm: NgForm) {
    const expedition = this.sesion.expedition$.getValue();

    if (!this.acceptPolicyPrivacy) {
      frm.controls.acceptPolicyPrivacy.markAsTouched();
      frm.controls.acceptPolicyPrivacy.setErrors({ 'politicaPrivacidad': this.langService.instant('ModifyDelivery.PrivacyPolicyInfo') }, { emitEvent: true })

    }

    if(this.zipCode === ''){
      frm.controls.zipCode.markAsTouched();
      frm.controls.zipCode.setErrors({ 'zipCode': this.langService.instant('ModifyDelivery.WrongZipCodeInfo') }, { emitEvent: true })
      return;
    }

    const validation = await this.service.validateZipCode(expedition.TLGNumber, this.zipCode).toPromise();
    if(!validation){
      frm.controls.zipCode.markAsTouched();
      frm.controls.zipCode.setErrors({ 'zipCode': this.langService.instant('ModifyDelivery.WrongZipCodeInfo') }, { emitEvent: true })
      return;
    }
   

    if (frm.invalid) {
      return;
    }
    this.sesion.gaConfirmacion(this.change.type);
    let agregar = true;
    this.sesion.changes.forEach((change, index) => {
      if (change.type == this.change.type) {
        this.sesion.changes[index] = change;
        agregar = false;
      }
    });

    if (agregar) {
      this.sesion.changes.push(this.change);
      this.sesion.changesMade = this.sesion.changesMade | this.change.type;
    }

    for (let index = this.sesion.changesAvailable.length - 1; index >= 0; index--) {
      const change = this.sesion.changesAvailable[index];
      if ((change.type & this.changesAvailable) != change.type && change.type != this.change.type) {
        this.sesion.changesAvailable.splice(index, 1);
      } else if (change.type != this.change.type) {

        this.router.navigate(this.routeChange(change));
      }
    }

    this.modal.hide();
  }
  private routeChange(change: Change): Array<any> {
    let hijo = this.route.root.snapshot.firstChild;
    const route = new Array<any>();
    let encontradaParteCambio = false;
    while (hijo) {
      if (hijo.data['tipoCambio'] && !encontradaParteCambio) {
        encontradaParteCambio = true;
        if (hijo.url.length > 1) {
          for (let i = 0; i < hijo.url.length - 1; i++) {
            route.push(hijo.url[i].path);
          }
        }
        route.push(change.currentLanguagePath);
      } else {
        hijo.url.forEach(url => {
          route.push(url.path);
        });
      }
      hijo = hijo.firstChild;
    }
    if (!encontradaParteCambio) {
      route.push(change.currentLanguagePath);
    }
    return route;
  }
}
